<div>
    <div class="d-flex flex-row title-bar">
        <div class="me-auto">
            <div>
                <span class="title1">{{title}}</span>
            </div>
        </div>

        <div class="form-inline my-3 my-lg-2">
            <div class="dropdown ">
                <button class="btn btn-sm dropdown-toggle my-1 my-lg-1 me-3 my-sm-0 btn-basic" >
                    Downloads
                </button>
                <div class="dropdown-download dropdown-content">
                    <!--<a href="{{apiUrl}}api/download/allScenarios" target="_new" class="dropdown-item" >All scenarios</a>-->
                      <a href="javascript:void(0);" class="dropdown-item" (click)="onDownloadAllScenariosClick()">All scenarios</a>
                      <a href="javascript:void(0);" class="dropdown-item" (click)="onDownloadLogsClick()" *ngIf="user?.isSuperAdmin">Logs</a>
                    
                  <!--  <a routerLink="" class="dropdown-item" (click)="onDownloadAllScenariosClick()">All scenarios</a>
                    <a href="" class="dropdown-item" (click)="onDownloadLogsClick()" *ngIf="user?.isSuperAdmin">Logs</a>
                    -->
                </div> 
            </div>
        </div>
        <div *ngIf="user">
            <div class="model-btn" *ngIf="!showModelOverlay && !showModelBar && !counterPartyName">
                <div class="btn btn-sm mr-3 btn-basic" (click)="openModellingPanel()">
                <span>
                    Modelling
                </span>
                </div>
            </div>
        </div>
        <div class="model-btn model-active " *ngIf="showModelOverlay || showModelBar">
            <div class="btn btn-sm btn-basic d-flex flex-row ">
                <span>
                    Modelling
                </span>
                <span class="logo-btn-small close "
                      (click)="onModellingTabClose()">
                </span>
            </div>
        </div>
    </div>
    <app-modelling-panel [showModelOverlay]="showModelOverlay"
                         (runModelConfig)="onRunModelConfig($event)" [trades]="trades" [enableModels]="title !== 'Overview'"
                         [tradeDataLoading]="tradeDataLoading" (refreshModelList)="onCreateNewModel()"></app-modelling-panel>
    <div *ngIf="showModelBar" class="d-flex flex-column model-box model-bar-shown">
        <div class="d-flex flex-row justify-content-between">
            <div class="px-p-20">
                <ng-container *ngIf="selectedTrade">
                    <span class="font-weight-bold bp2s-simu-fg">{{selectedTrade?.modelName}}</span>
                    <span class="px-mx-20">|</span>
                </ng-container>
                <span class="font-weight-bold" *ngIf="modellingConfig?.rolloverToCash">Rollover to Cash</span> <span
                class="font-weight-bold" *ngIf="!modellingConfig?.rolloverToCash">No rollover</span> <span
                class="px-mx-20">|</span>
                <span class="font-weight-bold">Tail probability: </span>
                <span>{{minTail * 100}} - {{maxTail * 100}}%</span>
            </div>
            <div class="px-p-20">
                <button class="btn btn-sm my-2 me-3 my-sm-0 btn-basic" (click)="onChangeButtonClick()">
                    CHANGE
                </button>
            </div>
        </div>
    </div>
</div>
<div *ngIf="showModelBar" class="model-panel-top"></div>
<!-- Pop-up spinner -->
<div class="loading-overlay" *ngIf="isLoading">
    <div class="loading-content">
      <div class="loading-spinner"></div>
      <div class="loading-message">Downloading, please wait...</div>
    </div>
  </div>

  <app-error-popup #errorPopup></app-error-popup>
